import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuColorFillOption} from '@Components/contextual-menu/components/contextual-menu-color-fill-option';
import type {RGBA} from '@Utils/color.util';
import {getRgbaArrayFromFabricColor} from '@Utils/color.util';
import {getColorObjectArrayFromFillColor} from '@Utils/color.util';
import {COLOR_OBJECT_IDS} from '@Components/poster-editor/components/poster-editing-side-panel/poster-editing-side-panel.types';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetKeyFromActiveItem} from '@Hooks/poster-editor/useGetKeyFromActiveItem';

interface VectorFillColorSectionProps {
  onClickColorFill(colorIndex: number): void;
}

export function VectorFillColorSection({...props}: VectorFillColorSectionProps): ReactElement | null {
  const activeItemId = useSingleActivePosterItemId();
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const fill = useGetKeyFromActiveItem('fill');

  if (!activeItem) {
    return null;
  }

  if (!activeItem.isVector() && !activeItem.isRectangle()) {
    return null;
  }

  if (fill === null || fill === undefined) {
    return null;
  }

  const getLabelFromIndex = (index: number): string => {
    if (typeof fill === 'string') {
      return window.i18next.t('pmwjs_color');
    }

    if (index === 0) {
      return window.i18next.t('pmwjs_color_one');
    }
    return window.i18next.t('pmwjs_color_two');
  };

  const getColorFill = (color: RGBA, index: number): ReactElement => {
    return (
      <ContextualMenuColorFillOption
        id={`vector-color-${index}`}
        key={`vector-color-swatch-${COLOR_OBJECT_IDS[index]}`}
        className={index === 1 ? 'spacing-m-b-4' : ''}
        label={getLabelFromIndex(index)}
        data={[
          {
            id: 'color-object',
            color: getColorObjectArrayFromFillColor([color]),
          },
        ]}
        onClick={(): void => {
          props.onClickColorFill(index);
        }}
      />
    );
  };

  const getColorSwatches = (): ReactElement[] => {
    const colors = getRgbaArrayFromFabricColor(fill);
    return colors.map((color, index) => {
      return getColorFill(color, index);
    });
  };

  return <div className="flex-v-row flex-column-reverse">{getColorSwatches()}</div>;
}
